import { render, staticRenderFns } from "./AdminUserCustomRateDialog.vue?vue&type=template&id=19cdbf88&scoped=true"
import script from "./AdminUserCustomRateDialog.vue?vue&type=script&lang=js"
export * from "./AdminUserCustomRateDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminUserCustomRateDialog.vue?vue&type=style&index=0&id=19cdbf88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdbf88",
  null
  
)

export default component.exports